import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

export default function CalendarContainer({
  filteredEvents,
  setSelectedEvent,
  setSelectedWorkEvent,
  setIsViewingEventModalOpen,
  setIsViewingWorkEventModalOpen,
  setIsEditing,
  getTitleColor,
}) {
  return (
    <>
      {/* Hide vertical scrollbar but keep scrolling */}
      <style>
        {`
          .fc .fc-scroller {
            overflow-y: scroll !important;
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          .fc .fc-scroller::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>

      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "",
        }}
        events={filteredEvents}
        height="100%"
        contentHeight="100%"

        eventClick={(clickInfo) => {
          const { title, extendedProps } = clickInfo.event;

          const eventData = {
            id: clickInfo.event.id,
            title,
            start: clickInfo.event.start,
            end: clickInfo.event.end,
            ...extendedProps,
          };

          setSelectedEvent(eventData);
          setIsEditing(false);

          if (extendedProps.event_type === "work") {
            // Work event
            setSelectedWorkEvent(eventData);
            setIsViewingWorkEventModalOpen(true);
            setIsViewingEventModalOpen(false);
          } else {
            // Normal event
            setSelectedEvent(eventData);
            setSelectedWorkEvent(null); // clear work event
            setIsViewingWorkEventModalOpen(false);
            setIsViewingEventModalOpen(true);
          }
        }}

        eventContent={(eventInfo) => {
          const { title, extendedProps} = eventInfo.event;
          const {
            event_type,
            description,
            primary_technician,
            additional_technicians,
            property,
          } = extendedProps;

          const baseClass =
            "p-2 border rounded cursor-pointer font-sans w-full overflow-hidden";

          const generalEvents = [
            "event",
            "travel",
            "office",
            "rest",
            "training",
            "no_job",
          ];

          // Birthday
          if (event_type === "birthday") {
            return (
              <div className={`${baseClass} ${getTitleColor(title, event_type)}`}>
                <div className="font-semibold truncate">{title}</div>
                <div className="text-xs text-gray-600 truncate">Birthday</div>
              </div>
            );
          }

          // Holiday
          if (event_type === "holiday") {
            return (
              <div className={`${baseClass} ${getTitleColor(title, event_type)}`}>
                <div className="font-semibold text-sm truncate">{title}</div>
              </div>
            );
          }

          // General events
          if (generalEvents.includes(event_type)) {
            return (
              <div
                className={`${baseClass} ${getTitleColor(
                  title,
                  event_type,
                  primary_technician
                )}`}
              >
                <div className="font-semibold truncate">{title}</div>
                <div className="text-xs text-gray-700 truncate">Technician: {primary_technician || "-"}</div>
              </div>
            );
          }

          // Work events
          return (
            <div className={`${baseClass} ${getTitleColor(title, event_type)}`}>
              <div className="font-semibold truncate">{description || title}</div>
              <div className="text-xs text-gray-700 truncate">Property: {property || "-"}</div>
              <div className="text-xs text-gray-700 truncate">Technician: {primary_technician || "-"}</div>
              <div className="text-xs text-gray-700 truncate">Additional Technician: {additional_technicians || "-"}</div>
            </div>
          );
        }}
      />
    </>
  );
}
